import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { getValueFormatter } from '../defaultSettings';

const StyCell = styled('button', {
    name: 'StyCell',
})({
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    cursor: 'pointer',
});

type AggregationRowCellRendererProps = {
    dataType: DataTypesT;
    context: {
        decimalPrecision: number;
        displayBy: string;
    };
} & ICellRendererParams;

const AggregationRowCellRenderer = (props: AggregationRowCellRendererProps) => {
    const { value, dataType, context } = props;
    const { t } = useTranslation();
    if (!value) return null;
    const valueFormater = getValueFormatter(dataType);

    return (
        <StyCell sx={{ flexDirection: 'column' }}>
            <strong>
                {t('table.sum', {
                    value: valueFormater({
                        value: value.sum,
                        context,
                    }),
                })}
            </strong>
            <strong>
                {t('table.average', {
                    value: valueFormater({
                        value: value.average,
                        context,
                    }),
                })}
            </strong>
        </StyCell>
    );
};

export default AggregationRowCellRenderer;
